import React from "react";
import {
  asterbrands,
  novumwall,
  polebase,
  redirock,
  rediscapes,
  rosetta,
  truemont
} from "./logos.js";

const svgs = {
  "angle-down": (
    <svg viewBox="0 0 256 512">
      <path d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" />
    </svg>
  ),
  "angle-right": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path d="M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z" />
    </svg>
  ),
  "external-arrow": (
    <svg width={12} viewBox="0 0 20 20" fill="currentColor">
      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
    </svg>
  ),
  "arrow-right": (
    <svg
      width="25px"
      height="48px"
      viewBox="0 0 25 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Path 2@2x</title>
      <g id="Round-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile_Rosetta_Landing_RD2_V1"
          transform="translate(-233, -6416)"
          stroke="#6b6b6b"
          strokeWidth="1"
        >
          <g id="Arrows" transform="translate(165, 6417)">
            <polyline
              id="Path"
              transform="translate(80.3493, 23) scale(-1, 1) translate(-80.3493, -23)"
              points="57.349345 11.349345 80.349345 34.650655 103.349345 11.349345"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  ),
  "arrow-left": (
    <svg
      width="25px"
      height="48px"
      viewBox="0 0 25 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Path@2x</title>
      <g id="Round-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile_Rosetta_Landing_RD2_V1"
          transform="translate(-164, -6416)"
          stroke="#6b6b6b"
          strokeWidth="1"
        >
          <g id="Arrows" transform="translate(165, 6417)">
            <polyline
              id="Path"
              transform="translate(11.6507, 23) translate(-11.6507, -23)"
              points="-11.349345 11.349345 11.650655 34.650655 34.650655 11.349345"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  ),
  bars: (
    <svg width={26} height={21} viewBox="0 0 448 512">
      <path d="M442 114H6a6 6 0 01-6-6V84a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6zm0 160H6a6 6 0 01-6-6v-24a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6zm0 160H6a6 6 0 01-6-6v-24a6 6 0 016-6h436a6 6 0 016 6v24a6 6 0 01-6 6z" />
    </svg>
  ),
  close: (
    <svg width={24} height={24} viewBox="0 0 320 512">
      <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" />
    </svg>
  ),
  flickr: (
    <svg viewBox="0 0 31 31" width={31} height={31}>
      <circle cx="21" cy="15.5" r="3.5" />
      <circle cx="11" cy="15.5" r="3.5" />
      <circle cx="15.5" cy="15.5" r="14.5" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 12.2 12.2">
      <g>
        <path
          fill="currentColor"
          d="M6.1.6C3 .6.6 3 .6 6.1s2.5 5.5 5.5 5.5 5.5-2.5 5.5-5.5S9.1.6 6.1.6m4 3.2H8.3c-.1-.7-.4-1.4-.7-2.1 1 .4 1.9 1.1 2.5 2.1m.6 2.3c0 .5-.1.9-.2 1.4h-2V6.1c0-.5 0-.9-.1-1.4h2c.2.4.3.9.3 1.4m-4.6 4.6c-.3 0-1-.8-1.3-2.3h2.6c-.4 1.5-1 2.3-1.3 2.3M4.6 7.5c-.1-.9-.1-1.9 0-2.8h2.9c.1.5.1.9.1 1.4 0 .5 0 .9-.1 1.4H4.6zM1.5 6.1c0-.5.1-.9.2-1.4h2c-.1.9-.1 1.8 0 2.8h-2c-.2-.5-.2-1-.2-1.4m4.6-4.6c.3 0 1 .8 1.3 2.3H4.8c.3-1.5 1-2.3 1.3-2.3m-1.5.2c-.4.7-.6 1.4-.7 2.1H2.1c.5-1 1.4-1.7 2.5-2.1M2.1 8.4h1.8c.1.7.3 1.4.7 2-1.1-.3-2-1.1-2.5-2m5.5 2c.3-.6.6-1.3.7-2.1h1.8c-.6 1-1.5 1.8-2.5 2.1"
        />
      </g>
    </svg>
  ),
  reddit: (
    <svg viewBox="0 0 31 31" width={31} height={31}>
      <path
        d="M13.583 17.196a1.1 1.1 0 01-1.105-1.092c0-.612.493-1.104 1.105-1.104.603 0 1.091.492 1.091 1.104 0 .604-.493 1.092-1.091 1.092zM27 15c0 6.077-4.923 11-11 11S5 21.077 5 15 9.923 4 16 4s11 4.923 11 11zm-5.868-1.827c-.417 0-.785.173-1.056.443-.993-.687-2.333-1.131-3.819-1.18l.772-3.473 2.457.555c0 .603.493 1.091 1.091 1.091.613 0 1.105-.501 1.105-1.105 0-.603-.492-1.104-1.105-1.104-.43 0-.798.257-.98.612l-2.714-.603c-.133-.036-.271.062-.306.195l-.848 3.832c-1.472.062-2.798.502-3.792 1.189a1.468 1.468 0 00-1.069-.452c-1.548 0-2.053 2.08-.639 2.785a3.252 3.252 0 00-.075.688c0 2.333 2.626 4.222 5.855 4.222 3.242 0 5.868-1.889 5.868-4.222 0-.236-.027-.479-.084-.701 1.388-.71.878-2.772-.661-2.772zm-3.056 5.154c-.807.807-3.376.794-4.152 0a.267.267 0 00-.368 0c-.111.111-.111.283 0 .381 1.011 1.011 3.872 1.011 4.888 0 .111-.098.111-.27 0-.381a.267.267 0 00-.368 0zM18.417 15c-.603 0-1.091.492-1.091 1.104 0 .604.493 1.092 1.091 1.092a1.099 1.099 0 100-2.196z"
        fill="currentColor"
      />
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 31 31" width={31} height={31}>
      <path
        d="M24.502 12.612a8.626 8.626 0 01-5.036-1.61v7.331A6.67 6.67 0 017.767 22.71a6.67 6.67 0 015.946-10.985v3.688a3.06 3.06 0 00-3.387 4.731 3.063 3.063 0 003.421 1.099 3.063 3.063 0 002.108-2.91V4h3.611a4.97 4.97 0 00.076.91 5.01 5.01 0 002.212 3.291c.815.538 1.77.826 2.748.826v3.585z"
        fill="currentColor"
      />
    </svg>
  ),
  "map-marker": (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_57_3)">
        <path
          d="M15 0C9.16506 0 4.41809 4.74697 4.41809 10.5819C4.41809 17.6848 14.1199 29.292 14.533 29.7827C14.6484 29.9198 14.8182 29.9992 14.9974 30C14.9983 30 14.9991 30 15 30C15.1782 30 15.3477 29.9221 15.4637 29.7867C15.8768 29.3043 25.5819 17.8889 25.5819 10.5819C25.5819 4.74697 20.835 0 15 0ZM15.0037 28.4288C13.0552 26.0055 5.63908 16.3982 5.63908 10.5819C5.63908 5.42031 9.8384 1.22099 15 1.22099C20.1616 1.22099 24.3609 5.42031 24.3609 10.5819C24.3609 16.564 16.9577 26.0339 15.0037 28.4288Z"
          fill="black"
        />
        <path
          d="M15 5.88458C12.5192 5.88458 10.5011 7.90272 10.5011 10.3834C10.5011 12.8642 12.5192 14.8823 15 14.8823C17.4807 14.8823 19.4988 12.8642 19.4988 10.3834C19.4988 7.90272 17.4807 5.88458 15 5.88458ZM15 13.6612C13.1926 13.6612 11.7221 12.1908 11.7221 10.3834C11.7221 8.57589 13.1925 7.10549 15 7.10549C16.8074 7.10549 18.2778 8.57589 18.2778 10.3834C18.2778 12.1908 16.8073 13.6612 15 13.6612Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_57_3">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "hero-cutout": (
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">
      <defs>
        <clipPath id="heroCutout" clipPathUnits="objectBoundingBox">
          <path d="M 0,0 L 0,1 L 0.82,0.88 C 0.82,0.88 0.92,0.88 0.94,0.72 L 0.94,0.72 1,0.2 1,0 Z" />
        </clipPath>
      </defs>
    </svg>
  ),
  "section-cutout": (
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">
      <defs>
        <clipPath id="sectionCutout" clipPathUnits="objectBoundingBox">
          <path d="M 1,1 L 1,0 L 0.05,0.1 C 0.05,0.1 0.02,0.1 0.02,0.2 L 0.02,0.2 0,0.8 0,1 Z" />
        </clipPath>
      </defs>
    </svg>
  ),
  pause: (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.0111694" width="5" height="15.0694" fill="currentColor" />
      <rect x="9" y="0.0111694" width="5" height="15.0694" fill="currentColor" />
    </svg>
  ),
  play: (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 8L0 16V0L14 8Z" fill="currentColor" />
    </svg>
  ),
  search: (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.366 0a6.366 6.366 0 0 1 5.084 10.2L16 14.75 14.75 16l-4.55-4.55A6.366 6.366 0 1 1 6.366 0zm0 1.768a4.598 4.598 0 1 0 0 9.196 4.598 4.598 0 0 0 0-9.196z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  "sign-in": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M344 80l120 0 0 352-120 0-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0zm1 193l17-17-17-17L217 111l-17-17L166.1 128l17 17 87 87L24 232 0 232l0 48 24 0 246.1 0-87 87-17 17L200 417.9l17-17L345 273z" />
    </svg>
  ),
  "sign-out": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M344 432l-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0 120 0 0 352-120 0zM17 239L0 256l17 17L145 401l17 17L195.9 384l-17-17-87-87 234.9 0 24 0 0-48-24 0L91.9 232l87-87 17-17L161.9 94.1l-17 17L17 239z" />
    </svg>
  ),
  "asterbrands-logo": asterbrands,
  "polebase-logo": polebase,
  "makepolebase-logo": polebase,
  "redi-rock-logo": redirock,
  "makeredi-rock-logo": redirock,
  "rosettahardscapes-logo": rosetta,
  "rosetta-logo": rosetta,
  "novumwall-logo": novumwall,
  "makerosetta-logo": rosetta,
  "redi-scapes-logo": rediscapes,
  "truemont-logo": truemont
};

export default svgs;
